module.exports = {"IPC_VERSION_EVENT":"get-version"}


//////////////////
// WEBPACK FOOTER
// ./src/constants.json
// module id = 725
// module chunks = 0